/**
 * Vague au bas des bannières vertes des pages intérieures (FAQ, glossaire,
 * blog, projets, carte, contact, presse, engagements, pages légales,
 * sectorielles…). Composant serveur, sans JavaScript.
 *
 * Retour du 12/10/2026 (photos 66 et 67) : la vague était dessinée à la
 * largeur de l'écran SANS hauteur fixe ; elle grandissait donc avec la
 * largeur (40 px à 1440, 71 px à 2560) et finissait par recouvrir le texte
 * de la bannière, dont la marge basse, elle, restait fixe. Sa hauteur est
 * désormais bornée (24 px sur mobile, 32 px sur tablette, 40 px au-delà),
 * le dessin s'étirant en largeur (`preserveAspectRatio="none"`) : la marge
 * basse des bannières (64 px au moins) la contient toujours.
 *
 * Deux dessins, ceux qui existaient déjà :
 *  - `douce` : une seule ondulation (pages de liste, pages légales) ;
 *  - `double` : deux ondulations (pages sectorielles, impact).
 */
const DESSINS = {
  douce: { viewBox: '0 0 1440 40', d: 'M0 40V20C360 0 720 0 1080 20C1260 30 1350 35 1440 40H0Z' },
  double: { viewBox: '0 0 1440 60', d: 'M0 60V30C240 0 480 0 720 30C960 60 1200 60 1440 30V60H0Z' },
} as const

export default function VagueBanniere({
  forme = 'douce',
  couleur = 'text-cream',
}: {
  forme?: keyof typeof DESSINS
  /** Classe de couleur du texte (la vague est peinte en `currentColor`) : celle de la section suivante. */
  couleur?: string
}) {
  const { viewBox, d } = DESSINS[forme]
  return (
    <div className="absolute bottom-0 left-0 right-0 pointer-events-none" data-vague-banniere="">
      <svg
        aria-hidden="true"
        focusable="false"
        viewBox={viewBox}
        preserveAspectRatio="none"
        fill="none"
        className={`block w-full h-6 md:h-8 lg:h-10 ${couleur}`}
      >
        <path d={d} fill="currentColor" />
      </svg>
    </div>
  )
}
